/**
 * Inline SVG icons used across the status page. Pure, dependency-free
 * presentational components — extracted from `App.tsx` so the markup is
 * reusable by sibling components without importing from the view file.
 */
import clsx from 'clsx';

export const ChevronRight = (p: { className?: string }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={p.className}
  >
    <path d="M6 4l4 4-4 4" />
  </svg>
);

export const ChevronDown = (p: { className?: string }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={p.className}
  >
    <path d="M4 6l4 4 4-4" />
  </svg>
);

export const CheckCircle = (p: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={p.className}
  >
    <circle cx={12} cy={12} r={10} />
    <path d="M8 12.5l3 3 5-6" />
  </svg>
);

export const AlertTriangle = (p: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={p.className}
  >
    <path d="M12 3l10 18H2L12 3z" />
    <path d="M12 10v5" />
    <circle cx={12} cy={18.4} r={0.6} fill="currentColor" />
  </svg>
);

export const Check = (p: { className?: string }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={p.className}
  >
    <path d="M3 8.5l3 3 7-8" />
  </svg>
);

export const SearchIcon = (p: { className?: string }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={p.className}
  >
    <circle cx={7} cy={7} r={4.5} />
    <path d="M10.5 10.5L14 14" />
  </svg>
);

export function TelegramGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      className={clsx(
        'h-4 w-4 transition-[filter] duration-150',
        'group-hover:[filter:drop-shadow(0_0_6px_rgba(29,152,220,.7))]',
      )}
    >
      <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
    </svg>
  );
}
